/* ahorro.in — Cold Alpine cart drawer (3e).
   Opens from the header BAG link and after Add to bag; removes lines; re-renders
   the drawer body from /cart?section_id=ahorro-cart-drawer. Without JS, BAG goes
   to /cart and Add to bag posts the form as normal. */
(() => {
  const drawer = document.querySelector('[data-ah-drawer]');
  if (!drawer) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sheet = drawer.querySelector('[data-ah-drawer-sheet]');
  const SECTION = 'ahorro-cart-drawer';
  const DURATION = 280;
  let lastFocus = null;

  const msg = (text) => {
    const el = drawer.querySelector('[data-ah-cart-msg]');
    if (el) el.textContent = text || '';
  };

  const open = () => {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('ah-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
    sheet.focus({ preventScroll: true });
  };

  const close = () => {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ah-lock');
    sheet.style.transform = '';
    setTimeout(() => { drawer.hidden = true; msg(''); }, DURATION);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  const setCount = (count) => {
    document.querySelectorAll('[data-ah-bag-count]').forEach((el) => {
      const grew = count > Number(el.textContent);
      el.textContent = count;
      if (grew) {
        // Restart the bump animation (styles in ahorro-motion.css).
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
  };

  // Brief "Added ✓" (or the button's own data-ah-added text) on the button, then
  // back to its label (which may hold Nova's price span).
  const flashAdded = (button) => {
    if (!button) return;
    const label = button.innerHTML;
    button.textContent = button.dataset.ahAdded || 'Added ✓';
    setTimeout(() => {
      button.innerHTML = label;
      try { if (window.baCurr && window.baCurr.refreshConversion) window.baCurr.refreshConversion(); } catch (err) { /* keep INR */ }
    }, 1600);
  };

  const refresh = async () => {
    const res = await fetch(`${root}cart?section_id=${SECTION}`, { credentials: 'same-origin' });
    const html = await res.text();
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ah-cart-body]');
    const body = drawer.querySelector('[data-ah-cart-body]');
    if (fresh && body) body.replaceWith(fresh);
    // Nova Multi Currency only converts on page load and jQuery ajax, so ask it
    // to convert the freshly rendered prices for foreign buyers.
    try { if (window.baCurr && window.baCurr.refreshConversion) window.baCurr.refreshConversion(); } catch (err) { /* keep INR */ }
    const cart = await fetch(`${root}cart.js`, { credentials: 'same-origin' }).then((r) => r.json());
    setCount(cart.item_count);
  };

  const busy = (on) => drawer.classList.toggle('is-busy', on);

  // Header BAG link → open the drawer instead of navigating.
  document.addEventListener('click', (e) => {
    const bag = e.target.closest('#ah-bag-link');
    if (bag) { e.preventDefault(); open(); return; }

    if (e.target.closest('[data-ah-drawer-close]')) { close(); return; }

    const remove = e.target.closest('[data-ah-remove]');
    if (remove) {
      e.preventDefault();
      busy(true);
      fetch(`${root}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.dataset.ahRemove, quantity: 0 }),
      })
        .then(refresh)
        .catch(() => msg('Could not update your bag. Try again.'))
        .finally(() => busy(false));
    }
  });

  // Product page form: the square button → Ajax add, re-render, open the drawer.
  // Buy now → add (unless it's already in the bag) and go straight to checkout.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-ah-add-form]');
    if (!form) return;
    e.preventDefault();
    const button = e.submitter || form.querySelector('[type="submit"]');
    const buyNow = button && button.hasAttribute('data-ah-buy-now');
    if (button) button.setAttribute('aria-busy', 'true');
    const variantId = Number(new FormData(form).get('id'));
    const goCheckout = () => { window.location.href = `${root}checkout`; };

    // Every piece is one of a kind: Shopify's cart will happily take a second
    // copy (checkout blocks it later), so refuse it here instead.
    fetch(`${root}cart.js`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        if (cart.items.some((item) => item.variant_id === variantId)) {
          if (buyNow) { goCheckout(); return null; }
          open();
          msg('This piece is already in your bag.');
          return null;
        }
        return fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        });
      })
      .then(async (res) => {
        if (!res) return;
        if (buyNow && res.ok) { goCheckout(); return; }
        const data = await res.json().catch(() => ({}));
        await refresh();
        if (res.ok) flashAdded(button);
        open();
        // 422 here means the piece sold out between page load and the tap.
        if (!res.ok) msg(data.description || 'Sorry, this piece just sold.');
      })
      .catch(() => form.submit())
      .finally(() => { if (button) button.removeAttribute('aria-busy'); });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Swipe down on the sheet to close (mobile bottom sheet only).
  let startY = null;
  let delta = 0;
  sheet.addEventListener('touchstart', (e) => {
    if (sheet.scrollTop > 0 || window.matchMedia('(min-width: 990px)').matches) return;
    startY = e.touches[0].clientY;
    delta = 0;
    drawer.classList.add('is-dragging');
  }, { passive: true });
  sheet.addEventListener('touchmove', (e) => {
    if (startY === null) return;
    delta = Math.max(0, e.touches[0].clientY - startY);
    sheet.style.transform = `translateY(${delta}px)`;
  }, { passive: true });
  sheet.addEventListener('touchend', () => {
    if (startY === null) return;
    drawer.classList.remove('is-dragging');
    startY = null;
    if (delta > 90) close();
    else sheet.style.transform = '';
  });
})();
